import React, { useState, useEffect } from "react";
const SAVE_FEEDBACK = process.env.REACT_APP_API_URL + "/saveFeedback";
const Feedback = ({
  activityId,
  gid,
  iid,
  conversationId,
  onSingleDislike,
  onMultipleDislikes,
}) => {
  const [feedbackType, setFeedbackType] = useState(null);

  useEffect(() => {
    // Check localStorage for feedback for this message
    try {
      const feedbackArr = JSON.parse(
        localStorage.getItem(iid + "-chatfeedback"),
      );

      if (Array.isArray(feedbackArr)) {
        const found = feedbackArr.find((f) => f.messageId === activityId);
        if (found) setFeedbackType(found.feedback);
      }
    } catch (e) {}
  }, [activityId, iid]);

  const sendFeedback = (type) => {
    // ...existing code...
    let body = {
      groupId: gid,
      messageId: activityId,
      feedback: type,
    };
    try {
      fetch(`${SAVE_FEEDBACK}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
    } catch (error) {}
    let getOldFeed = JSON.parse(localStorage.getItem(iid + "-chatfeedback"));
    if (getOldFeed === null) {
      getOldFeed = [];
    }
    let new_chat_state = [...getOldFeed];
    let getIndex = new_chat_state.findIndex(
      (index) =>
        index.messageId === activityId && index.conId === conversationId,
    );
    if (getIndex === -1) {
      new_chat_state.push({
        messageId: activityId,
        feedback: type,
        conId: conversationId,
      });
    } else {
      new_chat_state[getIndex].messageId = activityId;
      new_chat_state[getIndex].feedback = type;
      new_chat_state[getIndex].conId = conversationId;
    }
    localStorage.setItem(iid + "-chatfeedback", JSON.stringify(new_chat_state));
    setFeedbackType(type); // update state so UI updates immediately

    // --- Dislike logic ---
    if (type === "Dislike") {
      // Count unique dislikes for this conversation
      const uniqueDislikes = new_chat_state.filter(
        (f) => f.feedback === "Dislike" && f.conId === conversationId,
      );
      if (
        uniqueDislikes.length === 1 &&
        typeof onSingleDislike === "function"
      ) {
        onSingleDislike();
      } else if (
        uniqueDislikes.length >= 2 &&
        typeof onMultipleDislikes === "function"
      ) {
        onMultipleDislikes();
      }
    }
  };

  return (
    <>
      <hr
        style={{
          border: 0,
          borderTop: "1px solid #e5e7eb",
          margin: "10px 0 8px 0",
          width: "calc(100% - 6px)",
        }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontSize: "11px",
          marginTop: "0px",
          color: "#333",
          borderRadius: "6px",
          padding: "3px 6px 3px 6px",
          width: "100%",
          minWidth: 0,
          justifyContent: "center",
          boxSizing: "border-box",
        }}
      >
        <span style={{ fontWeight: 500, marginRight: 2 }}>
          Was this helpful?
        </span>
        {feedbackType === "Like" && (
          <button
            style={{
              ...btn,
              ...thumbBtn,
              border: "none",
              background: "#fff",
            }}
            aria-label="Helpful"
            onClick={() => sendFeedback("None")}
          >
            <span style={{ display: "flex", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="#22c55e"
              >
                <path d="M21.3,10.08A3,3,0,0,0,19,9H14.44L15,7.57A4.13,4.13,0,0,0,11.11,2a1,1,0,0,0-.91.59L7.35,9H5a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17.73a3,3,0,0,0,2.95-2.46l1.27-7A3,3,0,0,0,21.3,10.08ZM7,20H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H7Zm13-7.82-1.27,7a1,1,0,0,1-1,.82H9V10.21l2.72-6.12A2.11,2.11,0,0,1,13.1,6.87L12.57,8.3A2,2,0,0,0,14.44,11H19a1,1,0,0,1,.77.36A1,1,0,0,1,20,12.18Z"></path>
              </svg>
            </span>
          </button>
        )}
        {feedbackType === "Dislike" && (
          <button
            style={{
              ...btn,
              ...thumbBtn,
              border: "none",
              background: "#fff",
            }}
            aria-label="Not helpful"
            onClick={() => sendFeedback("None")}
          >
            <span style={{ display: "flex", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="#ef4444"
              >
                <path d="M19,2H6.27A3,3,0,0,0,3.32,4.46l-1.27,7A3,3,0,0,0,5,15H9.56L9,16.43A4.13,4.13,0,0,0,12.89,22a1,1,0,0,0,.91-.59L16.65,15H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2ZM15,13.79l-2.72,6.12a2.13,2.13,0,0,1-1.38-2.78l.53-1.43A2,2,0,0,0,9.56,13H5a1,1,0,0,1-.77-.36A1,1,0,0,1,4,11.82l1.27-7a1,1,0,0,1,1-.82H15ZM20,12a1,1,0,0,1-1,1H17V4h2a1,1,0,0,1,1,1Z"></path>
              </svg>
            </span>
          </button>
        )}
        {(!feedbackType ||
          (feedbackType !== null && feedbackType === "None")) && (
          <>
            <button
              onClick={() => sendFeedback("Like")}
              style={{
                ...btn,
                ...thumbBtn,
                border: "none",
                background: "#fff",
              }}
              aria-label="Helpful"
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="#888"
                >
                  <path d="M21.3,10.08A3,3,0,0,0,19,9H14.44L15,7.57A4.13,4.13,0,0,0,11.11,2a1,1,0,0,0-.91.59L7.35,9H5a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17.73a3,3,0,0,0,2.95-2.46l1.27-7A3,3,0,0,0,21.3,10.08ZM7,20H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H7Zm13-7.82-1.27,7a1,1,0,0,1-1,.82H9V10.21l2.72-6.12A2.11,2.11,0,0,1,13.1,6.87L12.57,8.3A2,2,0,0,0,14.44,11H19a1,1,0,0,1,.77.36A1,1,0,0,1,20,12.18Z"></path>
                </svg>
              </span>
            </button>
            <button
              onClick={() => sendFeedback("Dislike")}
              style={{
                ...btn,
                ...thumbBtn,
                border: "none",
                background: "#fff",
              }}
              aria-label="Not helpful"
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="#888"
                >
                  <path d="M19,2H6.27A3,3,0,0,0,3.32,4.46l-1.27,7A3,3,0,0,0,5,15H9.56L9,16.43A4.13,4.13,0,0,0,12.89,22a1,1,0,0,0,.91-.59L16.65,15H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2ZM15,13.79l-2.72,6.12a2.13,2.13,0,0,1-1.38-2.78l.53-1.43A2,2,0,0,0,9.56,13H5a1,1,0,0,1-.77-.36A1,1,0,0,1,4,11.82l1.27-7a1,1,0,0,1,1-.82H15ZM20,12a1,1,0,0,1-1,1H17V4h2a1,1,0,0,1,1,1Z"></path>
                </svg>
              </span>
            </button>
          </>
        )}
      </div>
    </>
  );
};

const btn = {
  border: "none",
  background: "transparent",
  cursor: "pointer",
  fontSize: "14px",
  outline: "none",
  padding: 0,
  transition: "transform 0.1s, background 0.2s",
};

const thumbBtn = {
  // borderRadius removed for square/rectangular buttons
  width: 20,
  height: 20,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#fff",
  boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
  marginLeft: 1,
  marginRight: 1,
};

export default Feedback;
